import { withEventScope } from '@repo/event-processor';

import KittlPlusBannerComponent from 'components/KittlPlusBanner/KittlPlusBanner';
import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';

const KittlPlusBanner = (): JSX.Element | null => {
  return (
    <ContentWrapper customWidth="1000px">
      <KittlPlusBannerComponent />
    </ContentWrapper>
  );
};

export default withEventScope(KittlPlusBanner, { module: 'kittlPlusBanner' });
